import {
  Container,
  HeaderSurveyContent,
  SurveyContent,
  SurveyLabel,
  SurveyTitle,
  Card,
  CardContent,
  CardLabel,
  CardString,
  CardNumber,
} from "./styles";

interface HeaderSurveyProps {
  surveyTitle: string;
  surveyLocation: string;
  surveyTotalOfSamples: number;
  surveyTotalOfOperators: number;
}

function HeaderSurvey({
  surveyTitle,
  surveyLocation,
  surveyTotalOfSamples,
  surveyTotalOfOperators,
}: HeaderSurveyProps) {
  return (
    <Container>
      <HeaderSurveyContent>

        <SurveyContent>
          <SurveyLabel>Pesquisa</SurveyLabel>
          <SurveyTitle>
            {surveyTitle}
          </SurveyTitle>
        </SurveyContent>
      </HeaderSurveyContent>

      <Card>
        <CardContent>
          <CardLabel>Local da pesquisa:</CardLabel>
          <CardString>{surveyLocation}</CardString>
        </CardContent>

        <CardContent hasBordersLeftAndRight marginRight>
          <CardLabel>Amostra presencial</CardLabel>
          <CardNumber>{surveyTotalOfSamples}</CardNumber>
        </CardContent>

        <CardContent>
          <CardLabel>Operadores</CardLabel>
          <CardNumber>{surveyTotalOfOperators}</CardNumber>
        </CardContent>
      </Card>
    </Container>
  );
}

export default HeaderSurvey;
